import { render, staticRenderFns } from "./PersonBuyer.vue?vue&type=template&id=258af19e&scoped=true&"
import script from "./PersonBuyer.vue?vue&type=script&lang=js&"
export * from "./PersonBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258af19e",
  null
  
)

export default component.exports